import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    OnDestroy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/shared/email-validator/email.validator';
import { FieldLength } from '../field-length';
import { View } from '../view.enum';
import { Apollo, gql } from 'apollo-angular';
import { NotificationService } from 'src/app/shared/notification/notification.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const sendResetPasswordEmailMutation = gql`
    mutation Mutation($customerID: ID!, $email: String!) {
        sendResetPasswordEmail(customerID: $customerID, email: $email) {
            email
        }
    }
`;

@Component({
    selector: 'ols-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    public form: FormGroup;
    @Output() messageSent: EventEmitter<void> = new EventEmitter();
    @Output() viewChange: EventEmitter<View> = new EventEmitter();
    private ngUnsubscribe: Subject<any> = new Subject();
    public isSendingEmail = false;
    public FieldLength = FieldLength;

    constructor(
        private fb: FormBuilder,
        private apollo: Apollo,
        private notificationService: NotificationService
    ) {}

    public ngOnInit(): void {
        this.form = this.fb.group({
            email: ['', [Validators.required, emailValidator]],
        });
    }

    public ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    public submitForm() {
        if (this.form.valid) {
            this.processResetEmail(this.form.value.email);
        }
    }

    public processResetEmail(email: string) {
        this.isSendingEmail = true;

        this.apollo
            .mutate({
                mutation: sendResetPasswordEmailMutation,
                variables: {
                    email: email,
                },
            })
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (response: any) => {
                    this.isSendingEmail = false;
                    if (response?.data?.sendResetPasswordEmail?.email) {
                        this.messageSent.emit();
                    } else if (response && response.errors) {
                        this.notificationService.showFailure(response.errors);
                    }
                },
                (err) => {
                    this.notificationService.showFailure(err);
                }
            );
    }

    public backToLogin() {
        this.viewChange.emit(View.LOGIN);
    }

    public getButtonText(): string {
        return this.isSendingEmail ? 'Sending Email' : 'Reset Password';
    }
}
